/**
 * Presentation-only helper for doctor display names. Does not mutate API or stored data.
 *
 * @param {object|null|undefined} doctorData
 * @param {string} [emptyFallback=''] Returned when name is null, undefined, or blank after trim
 * @returns {string}
 */
export function displayDoctorName(doctorData, emptyFallback = "") {
  const name = String(doctorData?.name ?? "").trim();
  if (!name) return emptyFallback;
  const salutation = String(doctorData?.salutation ?? "").trim();
  return salutation ? `${salutation} ${name}` : name;
}
